import { Link } from "react-router-dom";
import type { StoryFunnel } from "@quizzes/_story-funnel-schema";

export function StoryFunnelDetail({ story }: { story: StoryFunnel }) {
  return <div>
    <Link className="text-sm text-mars-orange hover:underline" to="/quizzes">All quizzes and stories</Link>
    <header className="mb-8 mt-3 flex flex-wrap items-start justify-between gap-4">
      <div>
        <span className="eyebrow">{story.slug}</span>
        <h1 className="heading mt-1 text-3xl">{story.meta.title}</h1>
        <p className="mt-2 text-sm text-mars-white/60">{story.screens.length} screens · Story to offer · Version {story.version}</p>
      </div>
      <div className="flex gap-4 text-sm text-mars-orange">
        <Link to={`/quizzes/${story.slug}/preview`}>Preview</Link>
        <Link to={`/quizzes/${story.slug}/analytics`}>Analytics</Link>
      </div>
    </header>
    <section className="mb-8 rounded-xl border border-mars-line p-5">
      <h2 className="eyebrow">Offer destination</h2>
      <a className="mt-2 block break-all text-sm text-mars-orange underline" href={story.offer.href} target="_blank" rel="noreferrer">{story.offer.href}</a>
      <p className="mt-2 text-sm text-mars-white/60">Each story has its own destination and screen sequence in its configuration.</p>
    </section>
    <h2 className="eyebrow mb-3">Screens</h2>
    <ol aria-label="Story screens" className="space-y-2">
      {story.screens.map((screen, index) => <li key={screen.id} className="rounded-xl border border-mars-line bg-mars-night px-5 py-4">
        <p className="mono text-xs text-mars-orange">{String(index + 1).padStart(2, "0")} · {screen.id} · {screen.role}</p>
        <h3 className="mt-2 text-sm text-mars-white">{screen.heading}</h3>
        <p className="mt-1 text-xs text-mars-white/60">{screen.blocks.length} content blocks · {screen.image ? "Image configured" : "Image pending"} · {screen.cta}</p>
      </li>)}
    </ol>
  </div>;
}
